const en = {
  "PREGUNTAS FRECUENTES": "FAQS",
  "Aprendé a": "Aprende a",
  "programar": "programar",
  "Cambiá": "Cambia",
};

export default en;
